/** Session key of the URL id mask (`utils/recordIds`); base of the masked token. */
export const RECORD_ID_KEY_STORAGE = 'neoprof.recordIdKey';
export const RECORD_ID_RADIX = 36;
